/**
 * Copyright Mántum All Rights Reserved.
 */
import Body from './body';
import Button from '../../components/common/button/text';
import useOpen from '../../hooks/useOpen';
import { forwardRef } from 'react';

import {
    XMarkIcon,
    ArrowsPointingOutIcon,
    ArrowsPointingInIcon
} from '@heroicons/react/24/outline';

import type { Scroll } from '@mantum/kanela';

type PropTypes = {
    action?: React.ReactNode;
    children?: React.ReactNode;
    className?: string;
    onClose?: () => void;
    open?: boolean;
    title?: string;
    fullScreen?: boolean;
};

export default forwardRef<Scroll, PropTypes>(function Index(props, ref) {
    // prettier-ignore
    const {
        onToggle,
        value: isFullScreen
    } = useOpen(props.fullScreen)

    return (
        <Body
            className={props.className}
            fullScreen={isFullScreen}
            open={props.open}
            ref={ref}
        >
            <div className='mb-8 flex w-full flex-col justify-center'>
                <div className='mb-2 flex w-full flex-col justify-center'>
                    <h2 className='mb-2 basis-3/4 text-2xl font-medium leading-7 text-gray-900 sm:truncate  sm:tracking-tight'>
                        {props.title}
                    </h2>
                </div>
                <div className='flex w-full basis-1/4 justify-between gap-4'>
                    <div className='flex w-full justify-end gap-2'>
                        {props.action}
                        <div className='hidden lg:block'>
                            <Button testid='fullscreen' onClick={onToggle}>
                                <span className='flex items-center justify-center'>
                                    {isFullScreen ? (
                                        <ArrowsPointingInIcon className='h-5 w-5' />
                                    ) : (
                                        <ArrowsPointingOutIcon className='h-5 w-5' />
                                    )}
                                </span>
                            </Button>
                        </div>
                    </div>
                    <div className='flex gap-2'>
                        <Button testid='close' onClick={props.onClose}>
                            <span className='flex items-center justify-center'>
                                <XMarkIcon className='h-5 w-5' />
                            </span>
                        </Button>
                    </div>
                </div>
            </div>
            {props.children}
        </Body>
    );
});
